// extracted by mini-css-extract-plugin
export default {"block":"Header_block__+vuBT","container":"Header_container__oYVB+","right":"Header_right__846cD","balance":"Header_balance__MNt5R"};